<template>
  <ApplicationLayout
    :user="user"
    :options="options"
    :version="version"
    :links="links"
    :showActionItems="true"
  >
    <!-- Set System bar content if enabled-->
    <template #systembar> </template>

    <!-- Set Appbar title-->
    <template #title>
      <v-icon class="mr-2">mdi-account-supervisor-outline</v-icon>
      <v-toolbar-title class="font-weight-bold d-flex">
        CRM Pro
      </v-toolbar-title>
    </template>

    <!-- Use to add addition items to Appbar -->
    <template #toolbar>
      <ReportIssueButton />
      <NotificationMenu />
    </template>

    <!-- Use change Navbar header content-->
    <template #navheader> </template>

    <!-- Use display content-->
    <template #content>
      <router-view />
    </template>
  </ApplicationLayout>
</template>

<script>
import ApplicationLayout from '@/modules/shared/components/core/layouts/ApplicationLayout.vue';
import NotificationMenu from '@/modules/shared/components/core/NotificationMenu.vue';
import ReportIssueButton from '@/modules/shared/components/core/ReportIssueButton.vue';
import PageMixin from '@/mixins/page.mixin';
import crmLinks from '@/modules/cmr-pro/routes/links.json';

const layoutOptions = {
  showSystemBar: false,
  showSearchBar: false,
  showUserOptions: true,
  showMenuToggle: true,

  appBarColor: '#fafbfc',
  miniDrawerColor: '',
  miniDrawerIconsColor: 'white',
  leftDrawerColor: 'white',
  leftDrawerIconsColor: ''
};

export default {
  components: { ApplicationLayout, NotificationMenu, ReportIssueButton },
  mixins: [PageMixin],
  data: () => ({
    options: layoutOptions,
    links: crmLinks
  })
};
</script>
